module.exports = __webpack_public_path__ + "public/SiteIcons/hostStepIcons/nameDesc.svg?3b2caca1";